import { DEV_FEATURES, STG_FEATURES, YOKOHAMA_FEATURES } from 'constants/feature';
import React, { createContext, useContext, useState, useEffect } from 'react';
const FeatureToggleContext = createContext();

const FeatureToggleProvider = ({ children }) => {
    const [features, setFeatures] = useState({});
    const [environment, setEnvironment] = useState('');
    const featureToggleService = new FeatureToggleService();


    useEffect(() => {
        setFeatures(featureToggleService.getAllFeatures());
        setEnvironment(featureToggleService.getEnvironment());
    }, []);

    const isFeatureEnabled = (featureName) => {
        return featureToggleService.isFeatureEnabled(featureName);
    };

    const value = {
        features,
        environment,
        isFeatureEnabled
    };

    return (
        <FeatureToggleContext.Provider value={value}>
            {children}
        </FeatureToggleContext.Provider>
    );
};

export default FeatureToggleProvider;

export const useFeature = (featureName) => {
    const context = useContext(FeatureToggleContext);
    return context.isFeatureEnabled(featureName);
};

export const useFeatures = (featureNames) => {
    const context = useContext(FeatureToggleContext);
    return featureNames.reduce((acc, featureName) => {
        acc[featureName] = context.isFeatureEnabled(featureName);
        return acc;
    }, {});
};

class FeatureToggleService {
    constructor() {
        this.features = {};
        this.environment = process.env.REACT_APP_ENV || 'dev';
        this.loadFeatures();
    }

    loadFeatures() {
        const envFeatures = {
            dev: DEV_FEATURES,
            stg: STG_FEATURES,
            yokohama: YOKOHAMA_FEATURES
        };

        this.features = envFeatures[this.environment] || envFeatures.dev;
    }

    getAllFeatures() {
        return this.features;
    }

    isFeatureEnabled(featureName) {
        return this.features[featureName] === true;
    }

    getEnvironment() {
        return this.environment;
    }
}
